import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { CmsEditorialArticle, CmsTaxonomyGeneral } from '@fcom/core-api';
import { SchemaService } from '@fcom/common/services/schema/schema.service';
import { toISO8601UTC } from '@fcom/core/utils/date';
@Component({
  selector: 'fin-article-bluewings',
  templateUrl: './article-bluewings.component.html',
  styleUrls: ['./article-bluewings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ArticleBluewingsComponent implements OnInit {
  private schemaService = inject(SchemaService);
  private document = inject<Document>(DOCUMENT);

  @Input()
  content: CmsEditorialArticle;

  ngOnInit(): void {
    const media = this.content.media.length ? this.content.media[0] : null;
    const firstPublished = this.content.localSettings?.firstPublished;

    this.schemaService.addArticleSchema({
      id: this.document.location.href,
      headline: this.content.teaserTitle,
      description: this.content.teaserText,
      dateModified: toISO8601UTC(new Date(this.content.creationDate)),
      datePublished: toISO8601UTC(new Date(firstPublished || this.content.creationDate)),
      image: {
        url: media?.['data'],
        width: media?.['width']?.toString(),
        height: media?.['height']?.toString(),
      },
    });
  }

  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;
}
